import useWbsImportMutation from "@/api/mutation/userWBSImportMutaion";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { errorConfig } from "@/lib/toastError";
import { t } from "i18next";
import { useRef } from "react";
import { toast } from "react-toastify";
import { Button } from "../ui/button";
import DownLoadIcon from "@/assets/svg/DownLoad.svg";
import { WBSCSVDownloadUrl } from "@/Environment";
import ExcelIcon from "@/assets/svg/Excel.svg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import useProjectQuery from "@/api/query/useProjectQuery";
import { useUser } from "@/hooks/useUser";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
import { Task } from "@/api/mutation/useTaskCreateMutation";
type Props = {
  projectId: string;
  refetch: () => void;
  iconOnly?: boolean;
  newTask:(data:Task[])=>void
};
function WbsImport(props: Props) {
  const labelStyle = "font-medium text-base text-gray-450/30";
  const wbsImportMutation = useWbsImportMutation(props.projectId);
  const csvUplodeRef = useRef<HTMLInputElement>(null);
  const uploadCsv = () => {
    if (
      csvUplodeRef.current &&
      csvUplodeRef.current.files &&
      csvUplodeRef?.current?.files[0]
    ) {
      const formData = new FormData();
      formData.append("csv", csvUplodeRef?.current?.files[0]);
      wbsImportMutation.mutate(formData, {
        onSuccess(data) {
          toast.success(data.data.message);
          if (csvUplodeRef?.current) {
            csvUplodeRef.current.value = "";
          }
          props.newTask(data.data.data)
          props?.refetch();
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };
  const downloadCsv = () => {
    const ac = document.createElement("a");
    ac.href = WBSCSVDownloadUrl;
    ac.download;
    ac.click();
  };
  const projects = useProjectQuery();
  const user = useUser();
   const isCollaborator = () => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == props.projectId
    );
    if (
      user.user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR
    ) {
      return true;
    } else if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.PROJECT_MANAGER
      )
    ) {
      return true;
    } else if (
      project?.assignedUsers.find(
        (u) =>
          (u.user.userId == user.user?.userId &&
            u.projectRole == UserRoleEnumValue.COLLABORATOR) ||
          u.projectRole == UserRoleEnumValue.TEAM_MEMBER
      )
    ) {
      return false;
    } else {
      return false;
    }
  };
  return (
    <div className="">
      {!props.iconOnly && (
        <label className={labelStyle}>{t("Import your WBS")}</label>
      )}
      <input
        onChange={uploadCsv}
        type="file"
        accept=".xlsx"
        className="hidden"
        ref={csvUplodeRef}
      />
      {props.iconOnly ? (
        <div className="ml-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className="cursor-pointer">
                <TooltipProvider>
                  <Tooltip delayDuration={0}>
                    <TooltipTrigger asChild>
                      <div className="flex w-7">
                        <img src={ExcelIcon} className="w-4 min-w-4 mr-0.5" />
                        <img
                          src={DownLoadIcon}
                          className="w-2 min-w-2 mt-2 rotate-180"
                        />
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="text-sm">{t("import more task")}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-auto">
              {isCollaborator() &&<DropdownMenuItem>
                <Button
                  isLoading={wbsImportMutation.isPending}
                  disabled={wbsImportMutation.isPending}
                  variant={"link"}
                  onClick={() => csvUplodeRef.current?.click()}
                  className="w-full  py-5 mt-0.5 text-gray-600"
                >
                  <img
                    src={ExcelIcon}
                    className="mr-1 brightness-0  w-4 min-w-4"
                  />{" "}
                  {t("Upload a csv file")}
                </Button>
              </DropdownMenuItem>}
              <DropdownMenuItem>
                <Button
                  variant={"link"}
                  className="w-fit text-gray-600 justify-start"
                  type="button"
                  onClick={() => downloadCsv()}
                >
                  <div className="flex gap-2 ">
                    <img className="h-4 w-4" src={DownLoadIcon} />{" "}
                    {t("Download_sample_File")}
                  </div>
                </Button>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      ) : (
        <div>
          {isCollaborator() && <Button
            isLoading={wbsImportMutation.isPending}
            disabled={wbsImportMutation.isPending}
            variant={"outline"}
            onClick={() => csvUplodeRef.current?.click()}
            className="w-full border-2 py-5 mt-0.5 text-gray-600"
          >
            <div className="flex gap-1 items-center">
              <img src={ExcelIcon} className="brightness-0  w-4 min-w-4" />{" "}
              {t("Upload a csv file")}
            </div>
          </Button>}
          <Button
            variant={"link"}
            className="w-fit text-gray-600 justify-start"
            type="button"
            onClick={() => downloadCsv()}
          >
            <div className="flex gap-2 ">
              <img className="h-4 w-4" src={DownLoadIcon} />{" "}
              {t("Download_sample_File")}
            </div>
          </Button>
        </div>
      )}
    </div>
  );
}

export default WbsImport;
